const featureFlags = {
  // Here we can define the feature flags that we want to use in the app which are not coming from feature hub.
};

export default featureFlags;
